try {
    if (process.env.TOKENS_FEATURE_FLAG === 'true' || process.env.STORYBOOK_TOKENS_FEATURE_FLAG !== 'false') require('./index-new.css');
    else require('./index.css');
  } catch (e) {
    if (e.code !== 'MODULE_NOT_FOUND') {
      throw e; // Re-throw unexpected errors
    }
    console.warn('index.css / index-new.css not found, proceeding without it.');
  }


import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { forwardRef } from 'react';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function __rest(s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}

const GridContainer = forwardRef((_a, ref) => {
    var { tag: Tag = 'div', wrap, direction, rowSpacing = 0, columnSpacing = 0, justifyContent, alignItems, alignContent, className, children } = _a, htmlProperties = __rest(_a, ["tag", "wrap", "direction", "rowSpacing", "columnSpacing", "justifyContent", "alignItems", "alignContent", "className", "children"]);
    return (jsx(Tag, Object.assign({ className: classNames('cds-grid', `cds-grid--row-spacing-${rowSpacing}`, `cds-grid--column-spacing-${columnSpacing}`, className, {
            [`cds-grid--${wrap}`]: wrap,
            [`cds-grid--${direction}`]: direction,
            [`cds-justify--${justifyContent}`]: justifyContent,
            [`cds-align--${alignItems}`]: alignItems,
            [`cds-content--${alignContent}`]: alignContent,
        }), ref: ref }, htmlProperties, { children: children })));
});

const GridItem = forwardRef((_a, ref) => {
    var { tag: Tag = 'div', xxs = 12, xs, sm, md, lg, xl, xxl, justifyContent, alignItems, className, children } = _a, htmlProperties = __rest(_a, ["tag", "xxs", "xs", "sm", "md", "lg", "xl", "xxl", "justifyContent", "alignItems", "className", "children"]);
    return (jsx(Tag, Object.assign({ className: classNames('cds-grid-item', className, {
            [`xxs-${xxs}`]: xxs,
            [`xs-${xs}`]: xs,
            [`sm-${sm}`]: sm,
            [`md-${md}`]: md,
            [`lg-${lg}`]: lg,
            [`xl-${xl}`]: xl,
            [`xxl-${xxl}`]: xxl,
            [`cds-justify--${justifyContent}`]: justifyContent,
            [`cds-align--${alignItems}`]: alignItems,
        }), ref: ref }, htmlProperties, { children: children })));
});

export { GridContainer, GridItem };
